import { z } from "zod";

export const getOrganizationSchema = z.object({
	orgId: z.string(),
});

export type GetOrganizationSchema = z.infer<typeof getOrganizationSchema>;
